import React from 'react';
import './ToggleMenu.scss';

const ToggleMenu = ({ toggle, darkMode, label, tabIndex, role }) => {
    return (
        <div className={darkMode ? 'darkBg toggle' : 'toggle'} 
            onClick={toggle} onKeyPress={toggle} aria-label={label} 
            tabIndex={tabIndex} role={role}></div>
    );
}

export default ToggleMenu;